module.exports = __webpack_public_path__ + "static/media/renew-4.01a857b9.png";